<template>
  <div class="z-border-red" style="margin-bottom: 10px">
    <v-layout>
      <v-flex>
        <div class="ma-2">
          <v-checkbox
            :input-value="isCheck"
            :label="`Order No. ${order.id}`"
            style="display: inline-block; margin: 0"
            color="primary"
            @change="assignCb(order.id)"
          ></v-checkbox>
        </div>
      </v-flex>
      <v-flex>
        <div class="ma-2 text-xs-right">
          <template v-if="order.app == 'facebook'">
            <em class="fab fa-facebook-square" style="color: #3c5a99" />
          </template>
          <template v-else-if="order.app == 'line'">
            <em class="fab fa-line" style="color: #00c300" />
          </template>
        </div>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex xs12 sm7>
        <div style="border-right: 1px solid #eee; height: 100%">
          <template v-if="typeof orderDetailFormat == 'string'">
            <div class="pa-2">
              <nl2br tag="div" :text="order.productdetail"></nl2br>
            </div>
          </template>
          <template v-else-if="typeof orderDetailFormat == 'object'">
            <template v-for="(order, oindex) in orderDetailFormat">
              <v-layout :key="'order_' + oindex" wrap>
                <v-flex sm1 xs2>
                  <div class="ma-2">
                    <v-img :src="order.photourl" aspect-ratio="1" alt class="grey lighten-2">
                      <template #placeholder>
                        <v-layout fill-height align-center justify-center ma-0>
                          <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                        </v-layout>
                      </template>
                    </v-img>
                  </div>
                </v-flex>
                <v-flex sm7 xs6 style="word-break: break-word">
                  <div class="ma-2">
                    {{ order.name }} x {{ order.quantity }}
                    <template v-if="order.option">({{ order.option }})</template>
                  </div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <div class="ma-2">฿{{ order.price | decimalFormat }}</div>
                </v-flex>
              </v-layout>
              <v-divider v-if="oindex < orderDetailFormat.length - 1" :key="oindex"></v-divider>
            </template>
          </template>

          <div>
            <v-layout v-if="order.total != null && order.discount > 0">
              <v-flex>
                <div class="pa-2">{{ $t('Subtotal') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">฿{{ order.total | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.shippingcharge != null">
              <v-flex>
                <div class="pa-2">{{ $t('Shipping fee') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">฿{{ order.shippingcharge | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.discount > 0">
              <v-flex>
                <div class="pa-2">{{ $t('Discount') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">-฿{{ order.discount | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.amount != null">
              <v-flex>
                <div class="pa-2">{{ $t('Total') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">฿{{ order.amount | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <v-divider />

          <div class="pa-2">
            <img
              v-if="shippingType == 'normal'"
              src="/static/img/assets/payment/normal_charge_logo.png"
              alt
              class="responsive-img"
              style="max-height: 50px"
            />
            <img
              v-else-if="shippingType == 'ems'"
              src="/static/img/assets/payment/ems_charge_logo.png"
              alt
              class="responsive-img"
              style="max-height: 50px"
            />
            <img
              v-else-if="shippingType == 'kerry'"
              src="/static/img/assets/payment/kerry_charge_logo.png"
              alt
              class="responsive-img"
              style="max-height: 50px"
            />
            <template v-else>
              <template v-if="shippingType">
                <img
                  :src="'/static/img/assets/payment/' + shippingType + '_logo.png'"
                  alt
                  class="responsive-img"
                  style="max-height: 50px"
                  @error="onImageLoadFailure($event)"
                />
                <div v-if="shippingType == 'cod_charge'" class="caption">
                  {{ $t('cod_charge') }}
                </div>
              </template>
            </template>
          </div>
          <div class="ml-2">{{ $t(shippingType) }}</div>
          <v-divider />
          <v-layout>
            <v-flex class="pa-2">
              <div class="caption">
                <template v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  >หมายเลขเดอะวัน</template
                >
                <template v-else>{{ $t('Remark') }}</template>
              </div>
              <editable
                v-model="orderremark"
                :filter="'text'"
                :type="'text'"
                @edited="onEditRemark"
              ></editable>
            </v-flex>
          </v-layout>

          <div class="pa-2">
            <multiselect
              :key="order.id + '_bankname'"
              v-model="bankname"
              :options="monobobanklist"
              label="text"
              select-label
              selected-label
              :allow-empty="false"
              :searchable="false"
              deselect-label
              track-by="text"
              @select="onSelectBank"
            ></multiselect>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm5>
        <div style="word-break: break-word" class="pa-2">
          <a target="_BLANK" :href="`https://business.facebook.com/latest/${order.userid}`"
            >{{ order.first_name }} {{ order.last_name }}</a
          >

          <template
            v-if="
              selectedBot.pageid == '103012211224246' ||
              selectedBot.pageid == '635426456938760' ||
              selectedBot.pageid == '613259679129221' ||
              selectedBot.pageid == '101857778024677'
            "
          >
            <template v-if="typeof shippingAddressPosition == 'string'">
              <editable
                v-model="order.nameaddress"
                :type="'textarea'"
                :has-copy="true"
                @edited="$emit('updateOrder', 'save')"
              ></editable>
            </template>
            <template v-else>
              <a
                :href="`https://maps.google.com?q=${shippingAddressPosition.lat},${shippingAddressPosition.lng}`"
                target="_blank"
                style="word-break: break-word"
              >
                https://maps.google.com?q={{
                  `${shippingAddressPosition.lat},${shippingAddressPosition.lng}`
                }}
              </a>
            </template>
          </template>
          <template v-else>
            <edit-address
              v-model="order.nameaddress"
              :has-copy="true"
              @edited="$emit('updateOrder', 'save')"
            ></edit-address>
          </template>
          <div class="caption mt-3">{{ $t('Status') }}</div>
          <div class="primary--text">{{ order.userstatus ? order.userstatus : '-' }}</div>
          <template v-if="$store.state.centralPage.includes(selectedBot.pageid)">
            <div class="caption mt-3">{{ $t('Live name') }}</div>
            <div class="primary--text">{{ order.livename ? order.livename : '-' }}</div>
          </template>
          <div class="caption mt-3">{{ $t('Tag') }}</div>
          <template v-if="tags.length > 0">
            <v-chip
              v-for="(tag, index) in tags"
              :key="'tag_' + index"
              small
              outline
              color="primary"
              disabled
              >{{ tag }}</v-chip
            >
          </template>
          <template v-else>
            <div class="primary--text">-</div>
          </template>
        </div>
        <v-divider></v-divider>

        <div class="pa-2">
          <multiselect
            :key="order.id + '_status'"
            v-model="status"
            :options="orderStatusOptions"
            label="label"
            :allow-empty="false"
            :searchable="false"
            select-label
            selected-label
            deselect-label
            track-by="label"
            @select="onSelectOrderStatus"
          ></multiselect>

          <template v-if="order.status == 'shipped'">
            <div class="form-control pt-2">
              <textarea
                v-model="order.trackingno"
                type="text"
                class="form-control"
                :placeholder="$t('Tracking')"
                maxlength="2000"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                :disabled="
                  order.trackingno == null ||
                  order.trackingno == '' ||
                  order.trackingno.trim() == ''
                "
                @click="$emit('updateOrder', 'send')"
              >
                <em class="far fa-share-square" />
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else-if="order.status == 'canceled'">
            <div class="form-control pt-2">
              <input
                v-model="order.reason"
                type="text"
                class="form-control"
                :placeholder="$t('Reason')"
                maxlength="300"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
                @click="$emit('updateOrder', 'save')"
              >
                <em class="far fa-save" />
                &nbsp;
                {{ $t('Save') }}
              </v-btn>
              <v-btn
                outline
                color="primary"
                class="ma-0"
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
                @click="$emit('updateOrder', 'send')"
              >
                <em class="far fa-share-square" />
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else>{{ order.trackingno }}</template>
        </div>

        <v-layout>
          <v-flex>
            <div class="pa-2">
              <div>
                <template v-if="shippingType && shippingType == 'cod_charge'">
                  {{ $t('cod_charge') }}
                </template>
                <template v-else>
                  <template v-if="order.payment == 'banktransfer' || order.payment == 'transfer'">
                    {{ $t('Bank Transfer') }}
                  </template>
                  <template v-else-if="order.payment == 'cod'">{{ $t('cod_charge') }}</template>
                  <template v-else-if="order.payment == 'qrcode'">Qr Code</template>
                  <template v-else-if="order.payment == 'fbpay'">
                    {{ $t('Mobile Banking') }}
                  </template>
                  <template v-else-if="order.payment == 'credit'">{{ $t('Credit card') }}</template>
                  <template v-else>{{ order.payment }}</template>
                </template>
                <div v-if="order.transactionid" class="caption">{{ $t(order.transactionid) }}</div>
              </div>
              {{ order.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
            </div>
          </v-flex>
          <v-flex>
            <div class="pa-2">
              <div style="text-align: right">
                <print-all-covers-monobo
                  :orders="[order]"
                  :circle="true"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(true, $event)"
                ></print-all-covers-monobo>
                <print-all-covers
                  :orders="[order]"
                  :circle="true"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(false, $event)"
                ></print-all-covers>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <template>
      <div class="hr"></div>

      <a href="javascript:void(0);" style="text-decoration: none" @click="showDetail = !showDetail">
        <div class="text-xs-center" style="margin: 10px auto">
          {{ $t('Click to view slip') }}
          <i class="fas" :class="{ 'fa-chevron-down': showDetail, 'fa-chevron-up': !showDetail }" />
        </div>
      </a>
      <div
        v-show="showDetail"
        style="margin-bottom: 0; background: rgb(253, 253, 253); border-bottom-left-radius: 10px"
      >
        <upload-file-button
          :value="image"
          :outputtype="'base64'"
          @onUploaded="onUploaded"
        ></upload-file-button>
        <template v-if="showDetail">
          <template v-if="order.note == 'base64'">
            <template v-if="!loading">
              <load-base64
                :key="'slip_' + order.id + '_' + timestamp"
                v-model="image"
                :orderid="order.id"
              ></load-base64>
            </template>
          </template>
          <template v-else-if="order.note">
            <editable
              v-model="order.note"
              :filter="'image'"
              :type="'image'"
              @edited="$emit('updateOrder', 'save')"
            ></editable>
          </template>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './OrderSummaryItem.js'
import PrintAllCoversMonobo from './PrintAllCoversMonobo'
import UploadFileButton from '@/components/elements/UploadFileButton'
import LoadBase64 from './LoadBase64'
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import EditAddress from './EditAddress'
export default {
  components: {
    PrintAllCoversMonobo,
    UploadFileButton,
    'load-base64': LoadBase64,
    EditAddress: EditAddress
  },
  mixins: [mixin],
  data() {
    return {
      image: null,
      monobobanklist: [
        { text: 'ธนาคารกรุงเทพ', value: 'กรุงเทพ' },
        { text: 'ธนาคารที.เอ็ม.บี (ทหารไทย)', value: 'ที.เอ็ม.บี (ทหารไทย)' },
        { text: 'ธนาคารไทยพาณิชย์', value: 'ไทยพาณิชย์' },
        { text: 'ธนาคารกสิกรไทย', value: 'กสิกรไทย' },
        { text: 'ธนาคารยูโอบี', value: 'ยูโอบี' }
      ],
      bankname: null,
      orderremark: '',
      timestamp: moment().format('x'),
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    try {
      var split = this.value.remark.split(';;')
      if (split.length > 0) this.orderremark = split[0]
      if (split.length > 1) {
        var bankoption = this.monobobanklist.find((el) => {
          return el.value == split[1]
        })
        if (bankoption) {
          this.bankname = bankoption
        }
      }
    } catch (error) {
      this.orderremark = this.value.remark
    }
  },
  methods: {
    onEditRemark() {
      var remark = `${this.orderremark};;${this.bankname ? this.bankname.value : ''}`

      this.$set(this.order, 'remark', remark)
      this.$emit('updateOrder', 'save')
    },
    async onSelectBank(value) {
      this.bankname = value
      await this.$nextTick()
      this.onEditRemark()
    },
    async onUploaded(file) {
      if (file) {
        var response = await this.saveSlip(this.order.id, file)

        await this.$nextTick()
        // this.loading = true
        this.$set(this.order, 'note', file)
        this.timestamp = moment().format('x')
        // this.image = file
        // await this.$nextTick()
        // this.loading = false
      }
    },
    saveSlip(id, file) {
      return new Promise((resolve, reject) => {
        api.saveSlip(
          { params: { id: id, pageid: this.selectedBot.pageid }, data: { note: file } },
          function (error, response) {
            if (error) {
              reject(error)
              return
            }

            resolve(response)
          }
        )
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/MonoboSummaryItem.vue